import EqualHeightElementCollection from "@/ts/base/Components/EqualHeightElementCollection";

class Products extends EqualHeightElementCollection {
	getSelector(): string {
		return "li.product";
	}

	getComponents(): NodeListOf<HTMLElement>[] {
		return [
			document.querySelectorAll(".product > .product-wrap > .woocommerce-loop-product__link > h2"),
			document.querySelectorAll(".product > .product-wrap > .woocommerce-loop-product__link > .price"),
			document.querySelectorAll(".product > .product-wrap > .add_to_cart_btn")
		];
	}
}

export default Products;
